<template>
  <article class="sms">
    <div class="sms-relpy">
      <p class="personInfo">{{client.customer_name}}，{{client.mobile_number}}</p>
      <p class="client-message">{{client.content}}</p>
      <div class="line"></div>
      <div class="reply ">
        <textarea name="" class="reply-textarea" placeholder="请输入回复内容" @blur="onblur" v-model="content" maxlength="450"></textarea>
        <span id="textNumber">{{textNumber}}</span>
      </div>
    </div>
    <div class="share-box" v-if="isSend"></div>
    <div class="tip-filter-box" v-if="isSend">
      <div class="icon-tipico-ok"></div>
      <p>短信发送成功</p>
      <span>1秒后返回消息列表</span>
    </div>
    <section class="btn-bottom">
      <div class="btn-fix">
        <a class="btn" @click="onSubmit" href="javascript:void(0);">确认发送</a>
      </div>
    </section>
  </article>
</template>
<script>

export default {
  data () {
    return {
      content: '',
      sms_id: 0,
      isSend: false,
      client: {}
    }
  },
  created () { // 在实例被创建后使用
    this.sms_id = this.$route.params.id
    // 获取客户信息
    if (this.sms_id) {
      this.$rest.smsReply.getReceiveSms(null, this.sms_id).then((res) => {
        if (res.code === 0) {
          this.client = res.data
        } else if (res.code === 504) {
          this.showToast('网络超时啦！请检查网络。')
        }
      })
    }
  },
  computed: {
    // 限制字数输入
    textNumber () {
      let maxChars = 450
      let number = maxChars - this.content.length
      // if (number < 0) {
      //   this.content = this.content.substring(0, 450)
      //   return 0
      // }
      return number
    }
  },

  methods: {
    onblur () {
      // 前后字符串去空
      this.content = this.content.trim()
    },
    onSubmit () {
      if (this.content) {
        this.$rest.smsReply.sendSMS({ content: this.content }, this.sms_id).then((res) => {
          if (res.code === 0) {
            // 弹窗出现
            this.isSend = true
            // 回退
            setTimeout(() => {
              try {
                window.WeixinJSBridge.call('closeWindow')
              } catch (e) {
                throw new Error(`埋点错误WeixinJSBridge:${JSON.stringify(e)}`)
              }
            }, 1000)
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        this.showToast('请输入回复内容！')
      }
    }
  }
}
</script>

<style lang="less">
  .sms {
    min-height: 100%;
    background: #fff;
  }
</style>
